import { Sidebar, tokens } from 'ComponentLibrary'
import { SIDEBAR_WIDTH } from 'ClientPortal/src/pages/Orders/OrderManagementSidebar'
import { ChatCircleIcon, ListBulletsIcon, SquaresFourIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

function OrderSidebar() {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.orderSidebar' })
    const { t: tTerminology } = useTranslation('terminology', { keyPrefix: 'common' })
    const menuItems = [
        {
            icon: <SquaresFourIcon size={tokens.SizingIconS} weight="bold" />,
            label: t('overview'),
            slug: 'overview',
        },

        {
            icon: <ListBulletsIcon size={tokens.SizingIconS} weight="bold" />,
            label: tTerminology('tasks'),
            slug: 'tasks',
        },
        {
            icon: <ChatCircleIcon size={tokens.SizingIconS} weight="bold" />,
            label: tTerminology('messages'),
            slug: 'threads',
        },
    ]
    return (
        <Sidebar
            style={{ marginBottom: 'unset', minWidth: SIDEBAR_WIDTH, maxWidth: SIDEBAR_WIDTH }}
            elements={{
                [tTerminology('order')]: menuItems,
            }}
        />
    )
}

export { OrderSidebar }
